import { Typography } from '@/components/ui/typography';

import { RecentOrdersSection } from '../../property-shared/RecentOrdersSection';

interface Props {
  propertyId: string;
  totalElements: number;
  onViewAll: () => void;
}

export function PropertyOrdersCard({ propertyId, totalElements, onViewAll }: Props) {
  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <header className="mb-4">
        <Typography as="h2" variant="heading-md" className="font-semibold">
          Orders
        </Typography>
        <Typography className="text-sm text-muted-foreground">
          {totalElements} {totalElements === 1 ? 'order' : 'orders'} placed for this unit
        </Typography>
      </header>

      <RecentOrdersSection
        propertyId={propertyId}
        open={true}
        onViewAll={onViewAll}
      />
    </div>
  );
}
